import { useEffect } from "react";

import { toggleHideRequestLoader } from "@js/components/request-loader/slice";

import { useAppDispatch, useAppSelector } from "../redux";

export const useHideRequestLoader = () => {
  const dispatch = useAppDispatch();
  const hideRequestLoader = useAppSelector(
    (state) => state.requestLoader.hideRequestLoader,
  );

  useEffect(() => {
    if (!hideRequestLoader) {
      dispatch(toggleHideRequestLoader());
    }

    return () => {
      dispatch(toggleHideRequestLoader());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
